import { render } from "./BookmarkList.vue?vue&type=template&id=6e85085a&scoped=true"
import script from "./BookmarkList.vue?vue&type=script&lang=js"
export * from "./BookmarkList.vue?vue&type=script&lang=js"

import "./BookmarkList.vue?vue&type=style&index=0&id=6e85085a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e85085a"]])

export default __exports__